import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_OFFERS, SET_TAB } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import ArchiveSvg from '../other/svg/ArchiveSvg'
import { ListOffer } from 'dealer-types'
import FlatList from '../molecules/FlatList'
import ArchivedOnPlatformItemWrapper from '../molecules/ArchivedOnPlatformItemWrapper'
import OfferFilters from '../molecules/OfferFilters'
import OfferModal from './OfferModal'

const ArchivedOnPlatform = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { offers } = useSelector((state: RootReducer) => state.offersListReducer.sold)
  const containerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    dispatch(SET_TAB({ tab: 'sold' }))
    dispatch(FETCH_OFFERS({ tab: 'sold' }))
  }, [dispatch])

  return (
    <div>
      <Layout
        withoutToolbar={false}
        iconComponent={<ArchiveSvg className="w-8 h-8 text-white" />}
        withFiler={true}
        name={t('archive')}>
        <div ref={containerRef} className="h-full">
          <div className="h-[calc(100vh-200px)]">
            <OfferFilters containerRef={containerRef} />
            <FlatList
              data={offers}
              component={(itemProps: ListOffer) => <ArchivedOnPlatformItemWrapper {...itemProps} />}
              // eslint-disable-next-line require-await
              fetchMore={async () => {
                dispatch(FETCH_OFFERS({ tab: 'sold' }))
                // eslint-disable-next-line @typescript-eslint/return-await
                return Promise.resolve()
              }}
              itemMinWidth={'100%'}
            />
          </div>
        </div>
      </Layout>
      <OfferModal />
    </div>
  )
}

export default ArchivedOnPlatform
